import React from "react";
import Avatar from "../body/Avatar";
import Skills from "../body/Skills";
import siteContent from "../../generated/site-content";

function HomePage() {
  return (
    <section className="home-screen w-full py-1 lg:flex lg:min-h-full lg:items-center lg:py-0">
      <div className="home-grid grid w-full gap-6 lg:grid-cols-[minmax(0,15rem)_minmax(0,1fr)] lg:items-start xl:grid-cols-[17rem_minmax(0,1fr)]">
        <div className="flex justify-center lg:justify-start">
          <Avatar compact />
        </div>

        <div className="space-y-5 text-center lg:text-left">
          <div className="space-y-3">
            <div className="space-y-2">
              <p className="home-eyebrow theme-accent text-[0.65rem] font-semibold uppercase tracking-[0.28em] sm:text-xs">
                {siteContent.home.eyebrow}
              </p>
              <h1 className="home-headline theme-text font-semibold tracking-tight">
                {siteContent.home.headline}
              </h1>
            </div>

            <div className="home-copy theme-text-muted mx-auto max-w-3xl space-y-2.5 lg:mx-0 xl:max-w-5xl">
              <p>{siteContent.home.introParagraph}</p>
              <p>{siteContent.home.secondaryParagraph}</p>
            </div>
          </div>

          <Skills />
        </div>
      </div>
    </section>
  );
}

export default HomePage;
